const state = () => ({
    vigikBreadCrumb: [],
    classicBreadCrumb: [],
})

const getters = {
    getVigikBreadCrumb: (state) => {
        return state.vigikBreadCrumb
    },

    getClassicBreadCrumb: (state) => {
        return state.classicBreadCrumb
    },
}

const actions = {}

const mutations = {
    setVigikBreadCrumb(state, data) {
        state.vigikBreadCrumb = data
    },

    pushVigikBreadCrumb(state, data) {
        state.vigikBreadCrumb.push(...data)
    },

    setClassicBreadCrumb(state, data) {
        state.classicBreadCrumb = data
    },

    updateSepecificPartClassicBreadCrumb(state, data) {
        for (let i = 0; i < state.classicBreadCrumb.length; i++) {
            if (state.classicBreadCrumb[i].routeName === data.routeName) {
                state.classicBreadCrumb[i] = data
            }
        }
    },
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
}
